module.exports = __webpack_public_path__ + "static/media/outline-search-24px.63de706a.svg";